import { CouplingTypeOrdered } from '@application/types';
import { binarySelectOptions, enumSelectOptions, studPriceSelectOptions } from '@application/utils';
import {
  InputField,
  InputLabel,
  InputRadioField,
  InputSelectField,
  InputWrapper,
  SectionSubtitle,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { useFormikContext } from 'formik';
import type { FC } from 'react';
import type { MtAnimalBreederPageProps, MtAnimalsBreederPageFormValues } from '..';

export const MtStudBreederForm: FC<MtAnimalBreederPageProps> = (props) => {
  const { mode } = props;
  const { translate } = useTranslation();
  const { values } = useFormikContext<MtAnimalsBreederPageFormValues>();

  return (
    <>
      <SectionSubtitle>{translate('glossary.studs')}</SectionSubtitle>

      <InputWrapper>
        <InputLabel required>{translate('glossary.available')}</InputLabel>
        <InputRadioField<boolean>
          disabled={mode === 'view'}
          name="studInfo.availableForBreeding"
          options={binarySelectOptions(translate)}
        />
      </InputWrapper>

      {values.studInfo?.availableForBreeding && (
        <InputWrapper>
          <InputWrapper split>
            <InputLabel>{translate('common.inputs.champion.label')}</InputLabel>
            <InputRadioField<boolean>
              disabled={mode === 'view'}
              grow
              name="studInfo.champion"
              options={binarySelectOptions(translate)}
            />
          </InputWrapper>
          <InputWrapper split last>
            <InputLabel>{translate('common.inputs.femaleAccomodation.label')}</InputLabel>
            <InputRadioField<boolean>
              disabled={mode === 'view'}
              grow
              name="studInfos.accomodation"
              options={binarySelectOptions(translate)}
            />
          </InputWrapper>
          <InputWrapper split>
            <InputLabel required>{translate('common.inputs.studType.label')}</InputLabel>
            <InputSelectField<string>
              name="studInfo.type"
              disabled={mode === 'view'}
              options={enumSelectOptions(
                translate,
                'enum.couplingType',
                CouplingTypeOrdered as any,
              )}
            />
          </InputWrapper>
          <InputWrapper split last>
            <InputLabel>{translate('common.inputs.adn.label')}</InputLabel>
            <InputField name="studInfo.adn" disabled={mode === 'view'} />
          </InputWrapper>

          <InputWrapper>
            <InputLabel required>{translate('common.inputs.description.label')}</InputLabel>
            <InputField name="studInfo.description" textarea disabled={mode === 'view'} />
          </InputWrapper>

          <InputWrapper>
            <InputLabel required>{translate('common.inputs.price.label')}</InputLabel>

            <InputWrapper inline width="50%">
              <InputRadioField<boolean>
                disabled={mode === 'view'}
                name="studInfo.knownPrice"
                grow
                options={studPriceSelectOptions(translate)}
              />
            </InputWrapper>

            <InputWrapper inline width="50%">
              <InputField
                name="studInfo.price"
                disabled={mode === 'view' || !values.studInfo.knownPrice}
                type="number"
                inputMode="numeric"
              />
            </InputWrapper>
          </InputWrapper>
        </InputWrapper>
      )}
    </>
  );
};
